var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 17.1668C16.6666 17.3878 16.5788 17.5997 16.4225 17.756C16.2662 17.9123 16.0543 18.0001 15.8333 18.0001H4.16658C3.94557 18.0001 3.73361 17.9123 3.57733 17.756C3.42105 17.5997 3.33325 17.3878 3.33325 17.1668V9.66676H0.833252L9.43908 1.84343C9.59251 1.70383 9.79249 1.62646 9.99992 1.62646C10.2073 1.62646 10.4073 1.70383 10.5608 1.84343L19.1666 9.66676H16.6666C16.6666 12.5957 16.6666 14.2378 16.6666 17.1668Z",
    fill: "#E6E8EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 16.3333V11.3333H10.8334V16.3333H9.16675Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.3948,
    y1: 11.8596,
    x2: 8.06346,
    y2: 14.7953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED4DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d2e3cfc0962ff835af7185b48957227b.svg";
export { ForwardRef as ReactComponent };